import {
  CARD_TYPES,
  DEFAULT_IMAGE_SLIDE_DELAY,
  DEFAULT_VIDEO_SLIDE_DELAY,
  DEFAULT_VIDEO_SLIDE_DELAY_SECONDS,
} from './constants';
import { useDimensionTypeContext } from '../../context';
import { resolveVideoParams } from '../videoMedia/helpers';
import { useVideoMetadataContext } from '../../context/videoMetadataContext';

export const useGetSlideDelay = () => {
  const { isPortrait } = useDimensionTypeContext();
  const videoMetadataContext = useVideoMetadataContext();

  return slide => {
    const isVideoSlide =
      slide?.containerType?.toUpperCase() === CARD_TYPES.VIDEO;

    if (!isVideoSlide) {
      return DEFAULT_IMAGE_SLIDE_DELAY;
    }

    const { renderedVideoId } = resolveVideoParams({ isPortrait, ...slide });
    const durationInSeconds =
      videoMetadataContext[renderedVideoId]?.durationInSeconds;

    // Use actual video duration if shorter than default, otherwise use default
    if (
      durationInSeconds &&
      durationInSeconds < DEFAULT_VIDEO_SLIDE_DELAY_SECONDS
    ) {
      return durationInSeconds * 1_000;
    }

    return DEFAULT_VIDEO_SLIDE_DELAY;
  };
};
